import { globalVariables } from "helper/globalVariables";
import { backIcon, uploadWhite } from "helper/icons";
import { useMediaQuery } from "react-responsive";
import { useNavigate } from "react-router-dom";
import { Button } from "shared/Components/button";

export const AddDogHistory = () => {
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const navigate = useNavigate();

  return (
    <div className="App login-container-gradient pb-60 min-h-screen">
      <div className="sm:ml-6 lg:ml-80 pt-8 flex flex-col">
        <div className={`flex items-center ${isMobile && "ml-6"}`}>
          <span
            onClick={() => navigate(-1)}
            className="pr-4 pl-0 cursor-pointer"
          >
            <img src={backIcon} alt="" />
          </span>
          <span
            className={`${
              isMobile ? "text-[24px]" : "text-[30px]"
            } font-semibold text-gray-900`}
          >
            {globalVariables.addDogHistory}
          </span>
        </div>
        <div className="items-center flex flex-col justify-center mt-[280px]">
          <span className="text-xl font-semibold text-gray-900">
            {globalVariables.uploadDogHistory}
          </span>
          <div className="mt-2" />
          <span
            className={`text-base font-medium text-gray-700 ${
              isMobile && "w-[300px] text-center"
            }`}
          >
            {globalVariables.dogHistoryPublishedProfile}
          </span>
          <div className="mt-5" />
          <Button
            icon={uploadWhite}
            prefix={false}
            label={globalVariables.uploadHistory}
            width="w-[172px]"
          />
        </div>
      </div>
    </div>
  );
};
